export enum CourseMessageBoxType {
  InboxUnread = "InboxUnread",
  InboxRead = "InboxRead",
  Outbox = "Outbox",
}
